<script setup>
defineProps({
    value: String,
})
</script>

<template>
    <h1
        class="font-roboto mt-10 bg-linear-to-r from-cyan-500 via-red-400 via-[70%] to-red-500 bg-clip-text py-1 text-center text-6xl leading-[4.6rem] font-bold tracking-wide text-pretty text-transparent uppercase sm:text-7xl"
    >
        <template v-if="value">{{ value }}</template>
        <template v-else><slot /></template>
    </h1>
</template>
